import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const ConfirmDialog = ({open, title, content, confirmButtonLabel, cancelButtonLabel = "Cancel", onConfirm, onCancel, onClose, children = null, ...others}) => (
    <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="sm"
        {...others}
    >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>{content}</DialogContentText>
            {children}
        </DialogContent>
        <DialogActions>
            <Button key="cancel" onClick={onCancel}>
                {cancelButtonLabel}
            </Button>
            <Button
                key="save"
                variant="contained"
                color="primary"
                disableElevation
                disabled={!onConfirm}
                onClick={() => {
                    onConfirm();
                    onClose();
                }}
            >
                {confirmButtonLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
